import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Button, Dropdown } from "react-bootstrap";

import BaseActionForm from '../BaseActionForm';
import './styles.scss'
import LeftPanelHeader from './../../components/LeftPanelHeader';
import { prettyDateTime } from "../../utils/DateFunctions.js"
import * as actionTypes from "../../services/StoreContainer/actionTypes";
import { sendMetricContacts, sendMetricAction } from './../../services/MetricApi';

export default function Tarifs(props) {
    const dispatch = useDispatch();
    const userContainer = useSelector((store) => { return store.userReducer });

    return <TarifsClass
        {...props}
        dispatch={dispatch}
        userContainer={userContainer}
    />
}

class TarifsClass extends BaseActionForm {

    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        super.componentDidMount();

        this.lkApi.getTarif()
            .then(responces => {
                let tarif = responces[1];

                if (tarif && !tarif.errorMessageEn) {
                    this.setState({ tarif: tarif });
                }
            })
    }

    onRequestTarif = () => {
        let email = this.props.userContainer ? this.props.userContainer.userInfo.username : 'как сюда забрался аноним?';
        sendMetricAction(this.props.userContainer.metricId, "SELECT_TARIF", 'еще не определился с тарифом')
        sendMetricContacts(this.props.userContainer.metricId, email);

        this.setState({
            requested: true
        })

    }

    render() {
        return (
            <div className='twoHalfs'>
                <div id={"decomposer"} className={"flexColumn rightPanel"}>
                    {this.renderAlerts()}

                    <LeftPanelHeader
                        dataset={this.state.dataset}
                        sectionName={this.sectionName(actionTypes.MY_TARIF)}
                    />

                    <div className="postHeaderContainer textRoboto infoContainer">
                        {!this.state.tarif &&
                            <div>
                                <p className="textBottom">У вас не выбран никакой тариф, поэтому возможности личного кабинета ограничены.</p>
                                {this.state.requested
                                    ?
                                    <p className="textBottom">Спасибо за обращение! С вами свяжется наш менеджер и поможет выбрать подходящий тариф. Ваш контакт - {this.props.userContainer && this.props.userContainer.userInfo.username}</p>
                                    :
                                    <Button className='applyInstrument' onClick={this.onRequestTarif}>Связаться с нами</Button>
                                }
                            </div>
                        }
                        {this.state.tarif && !this.state.tarif.expired &&
                            <div>
                                <p className="textBottom">У вас сейчас действует «{this.state.tarif.name}»</p>
                                <p className="textBottom">Он будет действовать до {prettyDateTime(new Date(parseInt(this.state.tarif.expirationDate)))}</p>
                            </div>
                        }
                        {this.state.tarif && this.state.tarif.expired &&
                            <div>
                                <p className="textBottom">У вас действовал «{this.state.tarif.name}», он закончился {prettyDateTime(new Date(parseInt(this.state.tarif.expirationDate)))}</p>
                                {this.state.requested
                                    ?
                                    <p className="textBottom">Спасибо за обращение! С вами свяжется наш менеджер и поможет выбрать подходящий тариф. Ваш контакт - {this.props.userContainer && this.props.userContainer.userInfo.username}</p>
                                    :
                                    <Button className='applyInstrument' onClick={this.onRequestTarif}>Связаться с нами</Button>
                                }
                            </div>
                        }
                    </div>

                </div>

                <div className='rightHalf'></div>

            </div>
        );
    }
}

